module.exports = __webpack_public_path__ + "media/images/login_logo_ivba-219122bd39072e7cdc934cd7c4ba9f73.png";